module.exports = __webpack_public_path__ + "img/logo-login.f49dd31c.svg";